// to run this script: tap cmd-shift-1 on keyboard; enter `align_services_test_harness`
if (!window.custom_scripts) window.custom_scripts = {}
window.custom_scripts.align_services_test_harness = {
	input_required: true,
	fn: function(input) {
/*
Format for input:
*/
		return new Promise((resolve, reject)=>{
			if (input.search(/^(.*?)\n+([\s\S]+)/) == -1) {
				resolve('Couldn’t parse input')
				return
			}

			let service = RegExp.$1
			let payload = RegExp.$2
			if (empty(payload)) payload = {}
			else {
				// console.warn(payload)
				try {
					payload = JSON.parse(payload)
				} catch(e) {
					resolve('couldn’t parse payload')
					return
				}
			}

			if (payload.resourceUniverse) payload.resourceUniverse = JSON.stringify(payload.resourceUniverse)
			if (payload.competencyUniverse) payload.competencyUniverse = JSON.stringify(payload.competencyUniverse)

			U.ajax(`align/${service}`, payload, result=>{
				resolve(JSON.stringify(result, null, 4))
			})
		})
	},
}